import { render, staticRenderFns } from "./wc-profile.vue?vue&type=template&id=40b80d92&"
import script from "./wc-profile.vue?vue&type=script&lang=js&"
export * from "./wc-profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports